module.exports = __webpack_public_path__ + "static/ch5-SCENE-09-Turnaround_Tuesday-b482a2592844b3b7f922abbfe8937f11.mp4";